import { atomWithStorage } from "jotai/utils";

export const testModeAtom = atomWithStorage("testMode", false); // Initial value is false
